import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'

// get faclity List
export const getFaciltyData = (facilityUrl) => (dispatch) => {
  dispatch({ type: CONSTANTS.GET_FACILTY_REQUEST })
  return postRequest(APICONFIG.getFaclityUrl, facilityUrl).then((res) => {
    dispatch({ type: CONSTANTS.GET_FACILTY_SUCCESS, data: res })
    return res
  }).catch((err) => {
    dispatch({ type: CONSTANTS.GET_FACILTY_FAILURE })
    return err
  })
}

export const postCardPaymentDetails = (data) => (dispatch) => {
  dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_REQUEST })
  return postRequest(APICONFIG.postUrlForPayment, data).then((res) => {
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_SUCCESS, data: res })
    return res
  }).catch((err) => {
    dispatch({ type: CONSTANTS.POST_CARD_PAYMENT_FAILURE })
    return err
  })
}

// End Current Parking
export const endParking = (ticket_number) => (dispatch) => {
  dispatch({ type: CONSTANTS.END_PARKING_REQUEST })
  return getRequest(`${APICONFIG.endParking}/${ticket_number}`).then((res) => {
    dispatch({ type: CONSTANTS.END_PARKING_SUCCESS, data: res })
    return res
  }).catch((err) => {
    dispatch({ type: CONSTANTS.END_PARKING_FAILURE })
    return err
  })
}

export const downloadPass = (ticket_id) => (dispatch) => {
  // dispatch(addEventLog(ticket_id, CONSTANTS.PASS_DOWNLOAD_REQUEST))
  dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })
  // API URL with query parameter
  const apiUrl = `${APICONFIG.getPassDownload}?ticket_id=${ticket_id}`
  try {
    // Create a temporary anchor element to trigger the download
    const a = document.createElement('a')
    a.href = apiUrl
    a.download = `pass-${ticket_id}.pkpass` // Optional: specify filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    // Dispatch success actions
    // const resObject = { ticket_id }
    // dispatch(addEventLog(resObject, CONSTANTS.PASS_DOWNLOAD_SUCCESS))
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS })

    return Promise.resolve()
  } catch (err) {
    // const errObject = { ticket_id, error: err }
    // dispatch(addEventLog(errObject, CONSTANTS.PASS_DOWNLOAD_FAILURE))
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE })
    return Promise.reject(err)
  }
}
export const downloadGooglePass = (ticket_id) => (dispatch) => {
  // dispatch(addEventLog(ticket_id, CONSTANTS.PASS_DOWNLOAD_REQUEST))
  dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })
  // API URL with query parameter
  const apiUrl = `${APICONFIG.getGooglePassDownload}?ticket_id=${ticket_id}`
  return getRequest(apiUrl)
    .then((res) => {
      // const resObject = { ticket_id, response: res }
      // dispatch(addEventLog(resObject, CONSTANTS.PASS_DOWNLOAD_SUCCESS))
      dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS, data: res })
      // Handle the URL response
      // Option 1: Open the URL in a new tab
      window.open(res, '_blank')
      // Option 2: Create a temporary link and trigger click
      const a = document.createElement('a')
      a.href = res
      a.target = '_blank' // Open in new tab
      document.body.appendChild(a)
      a.click()
      a.remove()
      return res
    })
    .catch((err) => {
      // const errObject = { ticket_id, error: err }
      // dispatch(addEventLog(errObject, CONSTANTS.PASS_DOWNLOAD_FAILURE))
      dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE })
      return err
    })
}

